import { Step, StepButton, Stepper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';
import Loading from '../../../Components/Modals/Loading/Loader';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import swal from 'sweetalert';

import { PaginaCondiciones, PaginaRegistroCapacitaciones } from '../../../Components/Capacitaciones/Empleados/Pages';

import { AgregarCapacitacionesEmpleadosModal } from '../../../Components/Capacitaciones/Modal/AgregarCapacitacionesEmpleadosModal';

import {
  fetchCambiarSuccess,
  fetchCapacitacionesPeriodoActual,
  fetchEmpleadosInsert,
  fetchEstudiosGrados,
  fetchPeriodoActivo,
  fetchTiposCapacitaciones,
  selectCapacitacionesPeriodoActivo,
  selectEstudiosGrados,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectPeriodoActivo,
} from '../../../redux/Capacitaciones/CapacitacionesSlice';

import { selectUserData } from '../../../redux/Login/LoginSlice';

import { fetchEmpleados, selectAllEmpleados } from '../../../redux/Empleados/EmpleadosSlice';

import { meses } from '../../../utils/meses';

import moment from 'moment';
import { useNavigate } from 'react-router';

export const AgregarCapacitaciones = () => {
  // * VALIDACIONES DEL HOOK-FORM.
  const formSchema = Yup.object().shape({
    capacitacion: Yup.object().shape({
      id: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
      tipoId: Yup.number().when('nuevo', {
        is: true,
        then: (schema) => schema.required('El campo es requerido').notOneOf([0], 'El campo es requerido'),
        otherwise: (schema) => schema.notRequired(),
      }),
      descripcion: Yup.string(),
      nuevo: Yup.boolean().required(),
    }),
    servidorDetallesHabilidades: Yup.bool().nonNullable().required('El campo es requerido'),
    reflejosColaboradorCapacitacion: Yup.string().trim().required('El campo es requerido'),
    trimestre: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
    mes: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
    empleados: Yup.array(),
  });

  // * VALIDACIONES DEL HOOK-FORM EMPLEADOS.
  const formSchemaEmpleados = Yup.object().shape({
    empleado: Yup.object().shape({
      id: Yup.number(),
      empleadoId: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
      capacitacionId: Yup.number(),
      periodoId: Yup.number(),
      nombreGradoAlcanzado: Yup.string().trim().required('El campo es requerido'),
      gradoAlcanzado: Yup.number().nonNullable().notOneOf([0], 'El campo es requerido'),
      servidorDetallesHabilidades: Yup.string(),
      reflejosColaboradorCapacitacion: Yup.string(),
      trimestre: Yup.number(),
      mes: Yup.number(),
    }),
  });

  // ? HOOK-NAVIGATE
  const navigate = useNavigate();

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const capacitaciones = useSelector(selectCapacitacionesPeriodoActivo);
  const usuario = useSelector(selectUserData);
  const empleadosList = useSelector(selectAllEmpleados);
  const estudiosGrados = useSelector(selectEstudiosGrados);
  const periodoActivo = useSelector(selectPeriodoActivo);
  const isSuccess = useSelector(selectIsSuccess);
  const isLoading = useSelector(selectIsLoading);
  const message = useSelector(selectMessage);

  // ? HOOK-STATE PARA LA PAGINACION DE PAGINAS.
  const [stepPosition, setStepPosition] = useState(0);
  const [timeLeft, setTimeLeft] = useState(9);
  const [capacitacionesState, setCapacitacionesState] = useState([]);
  const [capacitacionNuevaAddState, setCapacitacionNuevaAddState] = useState({});

  // ? HOOK-STATE LISTAS
  const [empleadosListState, setEmpleadosListState] = useState([]);
  const [estudiosGradosState, setEstudiosGradosState] = useState([]);
  const [mesesState, setMesesState] = useState([]);

  // ? HOOK-STATE PARA EL MODAL
  const [open, setOpen] = useState({
    open: false,
    edit: false,
    empleado: {},
  });

  // ? HOOK-FORM
  const form = useForm({
    mode: 'onChange',
    shouldUnregister: false,
    resolver: yupResolver(formSchema, { abortEarly: true, validateAllFieldCriteria: false }),
    defaultValues: {
      capacitacion: {
        id: 0,
        tipoId: 0,
        descripcion: '',
        nuevo: false,
      },
      servidorDetallesHabilidades: null,
      reflejosColaboradorCapacitacion: '',
      empleados: [],
      trimestre: 0,
      mes: 0,
    },
  });

  const form2 = useForm({
    mode: 'onChange',
    shouldUnregister: false,
    resolver: yupResolver(formSchemaEmpleados, { abortEarly: true, validateAllFieldCriteria: false }),
    defaultValues: {
      empleado: {
        id: 0,
        empleadoId: 0,
        capacitacionId: 0,
        periodoId: 0,
        nombreGradoAlcanzado: '',
        gradoAlcanzado: 0,
        servidorDetallesHabilidades: '',
        reflejosColaboradorCapacitacion: '',
        trimestre: 0,
        mes: 0,
      },
    },
  });

  // ? HOOK-WATCH DE TRIMESTRE DEL FORM PRIMARIO
  const trimestreWatch = useWatch({
    control: form.control,
    name: 'trimestre',
    defaultValue: [],
  });

  // * FUNCION PARA CREAR UNA NUEVA CAPACITACION Y AGREGARLA EN LA LISTA.
  const funcAgregarNuevaCapacitacion = ({ descripcion }) => {
    const capacitacionNew = {
      id: Math.random(),
      descripcion,
      tipoId: 0,
      nuevo: true,
    };

    // * AÑADIENDO CAPACITACION A LA LISTA DE CAPACITACIONES.
    setCapacitacionesState([...capacitacionesState, capacitacionNew]);

    // * GUARDANDO LA CAPACITACION CREADA.
    setCapacitacionNuevaAddState(capacitacionNew);
  };

  // * FUNCION PARA REGISTRAR UN NUEVO EMPLEADO EN EL FORMULARIO PRINCIPAL.
  const onSaveEmpleado = (data) => {
    const empleados = [...form.watch('empleados'), data];

    form.setValue('empleados', empleados, { shouldValidate: true });
    setEmpleadosListState(empleadosListState.filter((x) => x.id !== data.empleado.empleadoId));

    // * LIMPIAR FORMULARIO.
    form2.reset();

    swal('Exito!', `El empleado ${data.empleado.nombreEmpleado} fue agregado.`, 'success');
  };

  // * FUNCION PARA ACTUALIZAR UN EMPLEADO.
  const onUpdateEmpleado = (data) => {
    const current = form.watch('empleados') || [];
    const exists = current.some((e) => e.empleado.empleadoId === data.empleado.empleadoId);

    const updated = exists
      ? current.map((e) =>
          e.empleado.empleadoId === data.empleado.empleadoId
            ? {
                ...e,
                ...data,
              }
            : e
        )
      : [...current, data];

    form.setValue('empleados', updated, { shouldValidate: true });

    setEmpleadosListState(empleadosListState.filter((x) => x.id !== data.empleado.empleadoId));

    swal('Exito!', `El empleado ${data.empleado.nombreEmpleado} fue actualizado con éxito.`, 'success');

    // * LIMPIAR FORMULARIO.
    form2.reset();

    // * CERRANDO MODAL.
    setOpen({ edit: false, empleado: {}, open: false });
  };

  // * FUNCION PARA ELIMINAR EMPLEADO DE LA LISTA.
  const funcDeleteEmpleado = (empleado) => {
    swal({
      title: `Esta seguro de eliminar a ${empleado.nombreEmpleado}?`,
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((answer) => {
      if (answer) {
        const empleadosListUpdated = form.watch('empleados').filter((x) => x.empleado.empleadoId !== empleado.empleadoId);

        form.setValue('empleados', empleadosListUpdated, { shouldValidate: true });

        setEmpleadosListState(
          empleadosListUpdated.length === 0
            ? empleadosList
            : empleadosList.filter((x) => empleadosListUpdated.some((e) => e.empleado.empleadoId !== x.id))
        );
      }
    });
  };

  // * FUNCION PARA ENVIAR DATA A BACK-END
  const funcSaveData = (data) => {
    if (data.empleados.length === 0) {
      swal('Error!', 'Debe seleccionar al menos un empleado para registrar la capacitación.', 'error');
      return;
    }

    const { empleados, capacitacion, trimestre, mes, servidorDetallesHabilidades, reflejosColaboradorCapacitacion } = data;

    const dataToApi = {
      capacitacion: capacitacion.nuevo
        ? {
            id: 0,
            descripcion: capacitacion.descripcion,
            tipoId: capacitacion.tipoId,
          }
        : {},
      capacitacionId: capacitacion.nuevo ? 0 : capacitacion.id,
      empleados: empleados.map((x) => x.empleado),
      periodoId: periodoActivo.id,
      mes,
      trimestre,
      servidorDetallesHabilidades,
      reflejosColaboradorCapacitacion,
    };

    dispatch(fetchEmpleadosInsert(dataToApi));
  };

  // ? REACT MEMO
  const PaginaCondicionesMemo = React.memo(PaginaCondiciones);
  const PaginaRegistroCapacitacionesMemo = React.memo(
    PaginaRegistroCapacitaciones,
    (prev, next) =>
      prev.stepPosition === next.stepPosition &&
      prev.setStepPosition === next.setStepPosition &&
      prev.funcAgregarNuevaCapacitacion === next.funcAgregarNuevaCapacitacion &&
      prev.funcSaveData === next.funcSaveData &&
      prev.capacitacionesState === next.capacitacionesState // o deepEqual si te hace falta
    // intencionalmente NO comparamos timeLeft
  );

  // dentro de tu componente padre:
  const paginas = React.useMemo(
    () => [
      { Pagina: PaginaCondicionesMemo, descripcion: 'Condiciones' },
      { Pagina: PaginaRegistroCapacitacionesMemo, descripcion: 'Registro de Capacitaciones' },
    ],
    []
  );

  const onAgregarNuevaCapacitacion = React.useCallback((...args) => funcAgregarNuevaCapacitacion(...args), [funcAgregarNuevaCapacitacion]);

  const onSaveData = React.useCallback((...args) => funcSaveData(...args), [funcSaveData]);

  // ? HOOK-EFFECT
  useEffect(() => {
    if (isSuccess === 'success' && message) {
      swal('Exitoso!', message, 'success');
      form.reset();
      form2.reset();
      setEmpleadosListState(empleadosList);
      setStepPosition(0);

      dispatch(fetchCambiarSuccess());
    } else if (isSuccess === 'error') {
      swal('Error', 'Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.', 'error');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (!periodoActivo || periodoActivo?.validacionCierreRegistroCapacitaciones) {
      navigate('/capacitaciones/empleados');
    }
  }, [periodoActivo]);

  useEffect(() => {
    // Si ya estamos en 0, no hagas nada
    if (timeLeft === 0) {
      return;
    }

    // Crea un intervalo que corre cada 1000ms (1s)
    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    // Limpia el intervalo cuando el componente se desmonta
    // o cuando cambie timeLeft (muy importante evitar fugas)
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    dispatch(fetchCapacitacionesPeriodoActual());
    dispatch(fetchTiposCapacitaciones());
    dispatch(fetchEstudiosGrados());
    dispatch(fetchPeriodoActivo());
  }, []);

  useEffect(() => {
    setCapacitacionesState(capacitaciones);
  }, [capacitaciones]);

  useEffect(() => {
    if (Object.keys(capacitacionNuevaAddState).length > 0) {
      form.setValue('capacitacion', capacitacionNuevaAddState);
      setCapacitacionNuevaAddState({});
    }
  }, [capacitacionesState]);

  useEffect(() => {
    const dataSolicitar = {
      skipRow: 0,
      rowsPerPage: 0,
      areaOrganizacionalId: usuario?.AreaOrganizacionalId,
      empleado: '',
      estado: 1,
    };

    dispatch(fetchEmpleados(dataSolicitar));
  }, [usuario]);

  useEffect(() => {
    if (empleadosList.length > 0) {
      setEmpleadosListState([...empleadosList, { id: 0, nombreLabel: 'Seleccionar Empleado' }]);
      setEstudiosGradosState([...estudiosGrados, { id: 0, descripcion: 'Seleccionar Grado' }]);
    }
  }, [empleadosList, estudiosGrados]);

  useEffect(() => {
    if (Object.keys(open.empleado).length > 0) {
      form2.setValue('empleado', open?.empleado);
    }
  }, [open]);

  useEffect(() => {
    let mesesCorrespondientes = [];

    switch (trimestreWatch) {
      case 1:
        mesesCorrespondientes = [1, 2, 3];
        break;

      case 2:
        mesesCorrespondientes = [4, 5, 6];
        break;

      case 3:
        mesesCorrespondientes = [7, 8, 9];
        break;

      case 4:
        mesesCorrespondientes = [10, 11, 12];
        break;

      default:
        break;
    }

    setMesesState(meses.filter((x) => mesesCorrespondientes.some((y) => y === x.noEntero)));
  }, [trimestreWatch]);

  // ? REACT-MEMO
  const HandleSteps = React.memo(function HandleSteps({ stepPosition }) {
    const { Pagina } = paginas[stepPosition];

    const children = React.useMemo(
      () => (
        <Pagina
          timeLeft={timeLeft} // si esto “tictac”, ignóralo en el comparator del hijo
          stepPosition={stepPosition}
          setStepPosition={setStepPosition}
          capacitacionesState={capacitacionesState}
          funcAgregarNuevaCapacitacion={onAgregarNuevaCapacitacion}
          funcSaveData={onSaveData}
          funcDeleteEmpleado={funcDeleteEmpleado}
          setOpen={setOpen}
          meses={mesesState}
        />
      ),
      [Pagina, stepPosition, setStepPosition, capacitacionesState, onAgregarNuevaCapacitacion, onSaveData, timeLeft, mesesState]
    );

    return children;
  });

  return (
    <Encabezado
      title={`Agregar Capacitaciones - ${moment(periodoActivo.fechaInicio).format('DD [de] MMMM yyyy')} a ${moment(periodoActivo.fechaFin).format('DD [de] MMMM yyyy')}`}
    >
      <Stepper alternativeLabel activeStep={stepPosition} sx={{ marginTop: 2 }}>
        {paginas.length > 0 &&
          paginas.map((item, index) => (
            <Step key={index}>
              <StepButton onClick={() => setStepPosition(index)}>{item.descripcion}</StepButton>
            </Step>
          ))}
      </Stepper>

      <div style={{ marginTop: '3%' }}>
        <FormProvider {...form}>
          <HandleSteps stepPosition={stepPosition} />
        </FormProvider>
      </div>

      <FormProvider {...form2}>
        <AgregarCapacitacionesEmpleadosModal
          onSaveEmpleado={open?.edit ? onUpdateEmpleado : onSaveEmpleado}
          empleadosListState={open?.edit ? empleadosList : empleadosListState}
          estudiosGradosState={estudiosGradosState}
          open={open}
          setOpen={setOpen}
        />
      </FormProvider>

      <Loading open={isLoading} />
    </Encabezado>
  );
};
